import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { SERVICE_GROUP_ID } from '@/constants';

type Props = {
  serviceGroupId: number;
};

export const BillingNoteHint: React.FC<Props> = ({ serviceGroupId }) => {
  let hintLink = '';
  if (serviceGroupId === SERVICE_GROUP_ID.emba) {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/8828099541145';
  } else if (serviceGroupId === SERVICE_GROUP_ID.hodaiplus) {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/21962351232025';
  } else {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/900002958343';
  }

  return (
    <StyledDiv>
      <Trans i18nKey={'pages.subscription.billingNote.hint'}>
        <a href={hintLink} rel="noopener noreferrer" target="_blank">
          link
        </a>
      </Trans>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  color: #4183c4;
  a {
    text-decoration: underline;
  }
`;
